(function(){
  // ===== Toast =====
  window.showToast = function(msg, isError){
    var t = document.getElementById('toast'); if(!t) return;
    t.textContent = msg;
    t.classList.toggle('error', !!isError);
    t.classList.add('show');
    clearTimeout(t._h);
    t._h = setTimeout(function(){ t.classList.remove('show'); }, 2200);
  };

  // ===== Cart drawer =====
  var drawer = document.getElementById('cart-drawer');
  function openDrawer(){ if(drawer){ drawer.classList.add('open'); document.body.style.overflow='hidden'; refreshCart(); } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('open'); document.body.style.overflow=''; } }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-open]')){ e.preventDefault(); openDrawer(); }
    if(e.target.closest('[data-cart-close]') || e.target.classList.contains('drawer__backdrop')){ closeDrawer(); }
  });

  function money(cents){
    var fmt = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '${{amount}}';
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, (cents/100).toFixed(2));
  }

  function renderCart(cart){
    var body = document.getElementById('cart-body');
    var total = document.getElementById('cart-total');
    var badge = document.querySelectorAll('[data-cart-count]');
    if(!body) return;
    badge.forEach(function(b){ b.textContent = cart.item_count; b.style.display = cart.item_count ? '' : 'none'; });
    if(!cart.items.length){
      body.innerHTML = '<p class="cart-empty">Your bag is empty.</p>';
      if(total) total.textContent = money(0);
      document.getElementById('cart-checkout').disabled = true;
      return;
    }
    document.getElementById('cart-checkout').disabled = false;
    body.innerHTML = cart.items.map(function(it){
      return '<div class="cart-line" data-key="'+it.key+'">'
        + '<div class="cart-line__img">'+(it.image?'<img src="'+it.image+'" alt="">':'')+'</div>'
        + '<div class="cart-line__body">'
        + '<div class="cart-line__title">'+it.product_title+'</div>'
        + (it.variant_title && it.variant_title!=='Default Title' ? '<div class="cart-line__meta">'+it.variant_title+'</div>' : '')
        + '<div class="cart-line__row">'
        + '<div class="cart-line__qty"><button type="button" data-qty-dec>−</button><span>'+it.quantity+'</span><button type="button" data-qty-inc>+</button></div>'
        + '<div style="display:flex;align-items:center;gap:8px"><strong>'+money(it.final_line_price)+'</strong><button type="button" class="cart-line__remove" data-remove aria-label="Remove">×</button></div>'
        + '</div></div></div>';
    }).join('');
    if(total) total.textContent = money(cart.total_price);
  }

  function refreshCart(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(renderCart);
  }

  function updateLine(key, qty){
    return fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){return r.json();}).then(renderCart);
  }

  document.addEventListener('click', function(e){
    var line = e.target.closest('.cart-line');
    if(!line) return;
    var key = line.dataset.key;
    var qty = parseInt(line.querySelector('span').textContent,10);
    if(e.target.matches('[data-qty-inc]')) updateLine(key, qty+1);
    if(e.target.matches('[data-qty-dec]')) updateLine(key, Math.max(0,qty-1));
    if(e.target.matches('[data-remove]')) updateLine(key, 0);
  });

  // ===== Add to cart from product cards =====
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-add-to-cart]');
    if(!btn) return;
    e.preventDefault();
    var id = btn.dataset.variantId;
    if(!id){ window.showToast('Unavailable', true); return; }
    btn.disabled = true;
    var oldText = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:id, quantity:1})
    }).then(function(r){ if(!r.ok) throw new Error(); return r.json(); })
      .then(function(){
        window.showToast('Added to bag');
        refreshCart();
        openDrawer();
      })
      .catch(function(){ window.showToast('Could not add', true); })
      .finally(function(){ btn.disabled = false; btn.textContent = oldText; });
  });

  // Checkout button
  document.addEventListener('click', function(e){
    if(e.target.id === 'cart-checkout'){ window.location.href = '/checkout'; }
  });

  // initial badge
  refreshCart();
})();
